module.exports = __webpack_public_path__ + "img/sameday.b01d6ad4.png";